import {
    IAgentUser,
} from './types';
import {
    IPatchBySuperAdminBody,
    IPatchByUserBody,
    IPostBySuperAdminBody,
    IRemindAgentComplaintsBody,
    ISendAgentMessageBody,
} from './types/requests';
import {
    IGetByUser,
    IGetOneByUser,
    IPatchBySuperAdmin,
    IPatchByUser,
    IPostBySuperAdmin,
    IRemindAgentComplaints,
    ISendAgentMessage,
} from './types/responses';
import {
    ICurrentPrepay,
} from 'entities/prepays/types/current-prepay';

import {
    useState,
} from 'react';
import {
    atom,
    useRecoilState,
} from 'recoil';

import Entity from '../../helpers/Entity';

import * as fetches from './fetches';

const agentsAtom = atom<IAgentUser[] | null>({
    key: 'agentsAtom',
    default: null,
});

export function useAgentsByUser() {
    const [agents, setAgents] = useRecoilState(agentsAtom);

    const getAgents = async (): Promise<IGetByUser> => {
        const res = await fetches.getByUser();

        if (!res.agents || res.error) {
            console.log(res.error);

            return res;
        }

        setAgents(res.agents);

        return res;
    };
    const updateAgent = async (dto: IPatchByUserBody): Promise<IPatchByUser> => {
        const res = await fetches.patchByUser(dto);

        if (!res.agent || res.error) {
            console.log(res.error);

            return res;
        }

        setAgents((agents) => {
            return Entity.replace(res.agent, agents);
        });

        return res;
    };
    const addToAgentTotalBalanceKopecks = (agentId: number, amountKopecks: number): void => {
        setAgents((agents) => {
            if (!agents) {
                return agents;
            }

            const agent = Entity.findOneById(agentId, agents);

            if (!agent) {
                return agents;
            }

            return Entity.replace({
                ...agent,
                totalBalanceKopecks: String(BigInt(agent.totalBalanceKopecks) + BigInt(amountKopecks)),
            }, agents);
        });
    };
    const updateAgentCurrentPrepay = (agentId: number, currentPrepay: ICurrentPrepay | null): void => {
        setAgents((agents) => {
            const agent = Entity.findOneById(agentId, agents);

            if (!agent) {
                return agents;
            }

            return Entity.replace({
                ...agent,
                currentPrepay,
            }, agents);
        });
    };
    const sendSupportMessage = async (
        dto: ISendAgentMessageBody
    ): Promise<ISendAgentMessage> => {
        const res = await fetches.sendSupportMessage(dto);

        if (res.error) {
            console.log(res.error);

            return res;
        }

        return res;
    };
    const sendFinanceMessage = async (
        dto: ISendAgentMessageBody
    ): Promise<ISendAgentMessage> => {
        const res = await fetches.sendFinanceMessage(dto);

        if (res.error) {
            console.log(res.error);

            return res;
        }

        return res;
    };

    const remindAgentComplaints = async (
        dto: IRemindAgentComplaintsBody
    ): Promise<IRemindAgentComplaints> => {
        const res = await fetches.remindAgentComplaints(dto);

        if (res.error) {
            console.log(res.error);

            return res;
        }

        return res;
    };

    return {
        agents,
        getAgents,
        updateAgent,
        addToAgentTotalBalanceKopecks,
        updateAgentCurrentPrepay,
        sendSupportMessage,
        sendFinanceMessage,
        remindAgentComplaints,
    };
}

export function useAgentByUser() {
    const [agent, setAgent] = useState<IAgentUser | null>(null);

    const getAgent = async (id: number): Promise<IGetOneByUser> => {
        const res = await fetches.getOneByUser(id);

        if (!res.agent || res.error) {
            console.log(res.error);

            return res;
        }

        setAgent(res.agent);

        return res;
    };
    const postAgentBySuperAdmin = async (body: IPostBySuperAdminBody): Promise<IPostBySuperAdmin> => {
        const res = await fetches.postBySuperAdmin(body);

        if (!res.agent || res.error) {
            console.log(res.error);

            return res;
        }

        setAgent(res.agent);

        return res;
    };
    const patchAgentBySuperAdmin = async (body: IPatchBySuperAdminBody): Promise<IPatchBySuperAdmin> => {
        const res = await fetches.patchBySuperAdmin(body);

        if (!res.agent || res.error) {
            console.log(res.error);

            return res;
        }

        setAgent(res.agent);

        return res;
    };
    const patchAgentByUser = async (body: IPatchByUserBody): Promise<IPatchByUser> => {
        const res = await fetches.patchByUser(body);

        if (!res.agent || res.error) {
            console.log(res.error);

            return res;
        }

        setAgent(res.agent);

        return res;
    };

    return {
        agent,
        getAgent,
        postAgentBySuperAdmin,
        patchAgentBySuperAdmin,
        patchAgentByUser,
    };
}
